module.exports = __webpack_public_path__ + "img/arrow-circle-grey.cd3c6da5.svg";